import { useIsExactPath } from 'hooks/useIsExactPath/useIsExactPath';
import { AppRoute } from 'routing/AppRoute.enum';

export const useGroupsArchivedView = () => {
  const isGroupsArchivedView = useIsExactPath(AppRoute.groupsArchived);

  return { isGroupsArchivedView: !!isGroupsArchivedView };
};
